import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager } from "../../AudioManager";

//export namespace SlotGames {

    export class AmazingPanda_2Screen extends SlotGameType1_2Screen {


        
        //protected panelFactory: IPanelFactory = new AmazingPandaPanelFactory();
        protected override helpFactory: IHelpFactory = new AmazingPandaHelpFactory();
        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "orange",
            };
        
        //LED COLOR
        protected override ColorLed: string = "0,255,0\n";



        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "AmazingPanda");


            //this.spinnableReelsParams.topBorderWidth = 10;
            //this.spinnableReelsParams.bottomBorderWidth = 10;
        }
    }

    //Panel Colorized
    class AmazingPandaPanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new AmazingPandaPanel(params);
        }
    }

    class AmazingPandaPanel extends Panel {
        protected override ButtonBackground(): ButtonColors {
            let color: ButtonColors = {
                backgroundButtonColor: "linear-gradient(rgb(43, 1, 0),rgb(72, 4, 1), rgb(127, 11, 5),rgb(72, 4, 1),rgb(43, 1, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                linearColor: "linear-gradient(to left , transparent, rgb(217, 179, 67),transparent ) 0 10 100%",
            };
            return color;

        }

    }

    //Help Colorized
    class AmazingPandaHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new AmazingPandaHelp(params);
        }
    }

    class AmazingPandaHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(43, 1, 0),rgb(72, 4, 1), rgb(127, 11, 5),rgb(72, 4, 1),rgb(43, 1, 0)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }
//}
